var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetain2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 260,
    height: 279.022,
    viewBox: "0 0 260 279.022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pzkhfi536a",
    x1: -11.898,
    x2: -10.898,
    y1: -13.386,
    y2: -13.386,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f79256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#faa572"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u4vn6bw2nb",
    x1: -21.092,
    x2: -20.092,
    y1: -22.061,
    y2: -22.061,
    xlinkHref: "#pzkhfi536a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2616.074 -253.94)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 59.737,
    cy: 59.737,
    r: 59.737,
    fill: "url(#pzkhfi536a)",
    opacity: 0.3,
    transform: "translate(2618.834 387.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 38.5,
    r: 38.5,
    fill: "url(#u4vn6bw2nb)",
    opacity: 0.3,
    transform: "translate(2780.43 346.279)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f79256",
    d: "M2841.772 254.937a4.884 4.884 0 0 0-3.616-.952l-119.049 16.193a4.885 4.885 0 0 0-4.182 5.5l1.882 13.839-44.2 18.529a4.883 4.883 0 0 0-2.616 6.392l35.839 85.5-17.772 23.362a14.646 14.646 0 0 0-12.846-4.706l-46.458 6.317a14.669 14.669 0 0 0-12.544 16.492l10.725 78.882a14.669 14.669 0 0 0 16.492 12.545l46.458-6.317a14.677 14.677 0 0 0 12.592-12.94l6.437 4.235a24.608 24.608 0 0 0 16.844 3.828l146.09-19.863a4.885 4.885 0 0 0 4.182-5.5l-32.375-238.107a4.884 4.884 0 0 0-1.883-3.229zm-149.022 256.4a4.889 4.889 0 0 1-4.181 5.5l-46.458 6.317a4.89 4.89 0 0 1-5.5-4.181l-10.725-78.883a4.889 4.889 0 0 1 4.182-5.5l18.39-2.5 7.58 55.749a4.884 4.884 0 0 0 9.679-1.316l-7.58-55.75 18.39-2.5a4.89 4.89 0 0 1 5.5 4.182l10.725 78.883zm-11.864-196.17l37.284-15.629 2.438 17.933-3.125 1.31a4.884 4.884 0 0 0-2.616 6.392 13.165 13.165 0 0 1-7.043 17.212 4.885 4.885 0 0 0-2.613 6.4l28.362 67.288-9.712 1.321-7.668-18.9a4.884 4.884 0 0 0-1.042-1.587zm42.74 24.5l5.552 40.837-13.27-31.484a22.877 22.877 0 0 0 7.718-9.358zm92.542 159.82l-91.728 12.472a14.842 14.842 0 0 1-10.16-2.308l-13.072-8.6-9.1-66.935 18.255-24 5.872 14.472a4.882 4.882 0 0 0 5.183 3l95.148-12.931a6.838 6.838 0 1 1 1.842 13.551l-48.753 6.629a4.884 4.884 0 1 0 1.316 9.679l63.9-8.689a6.838 6.838 0 0 1 1.843 13.551l-63.9 8.689a4.884 4.884 0 0 0 1.316 9.679l53.546-7.281a6.838 6.838 0 0 1 1.843 13.551l-53.546 7.28a4.884 4.884 0 0 0 1.315 9.68l37.039-5.036a6.837 6.837 0 1 1 1.842 13.549zm49.524-6.733l-34.534 4.7a16.555 16.555 0 0 0-1.842-13.551l1.519-.207a16.6 16.6 0 0 0 11.469-25.818 16.592 16.592 0 0 0 5.363-26.878l-8.339-61.336a4.884 4.884 0 0 0-9.68 1.316l7.488 55.07a16.669 16.669 0 0 0-3.58.095l-.158.022a16.6 16.6 0 0 0-18.147-21.192l-7.779 1.058a23.375 23.375 0 1 0-18.2 2.474l-26.454 3.6-12.512-92.02a22.993 22.993 0 0 0 14.992-19.71l36.4-4.95a22.991 22.991 0 0 0 19.71 14.992l2.046 15.046a4.884 4.884 0 0 0 9.679-1.316l-2.633-19.367a4.885 4.885 0 0 0-5.5-4.182 13.165 13.165 0 0 1-14.8-11.259 4.884 4.884 0 0 0-5.5-4.181l-45.045 6.125a4.884 4.884 0 0 0-4.181 5.5 13.165 13.165 0 0 1-11.259 14.8 4.886 4.886 0 0 0-4.182 5.5l13.1 96.34-9.452 1.285-18.424-135.5 109.37-14.876zm-68.382-93.3a13.606 13.606 0 1 1 11.648-15.315 13.621 13.621 0 0 1-11.647 15.313z",
    transform: "translate(2616.074 253.94) translate(-2616.075 -253.94)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetain2);
export default __webpack_public_path__ + "static/media/retain2.f99fa2b04ec06596d14022a9c652b975.svg";
export { ForwardRef as ReactComponent };